<template>
    <div class="linha2">
        <div class="main-header">
            <div class="empresa">
                <router-link :to="`/${$i18n.locale}/dashboard`">
                    <img
                        v-if="logoEmpresaAtual"
                        :src="logoEmpresaAtual"
                        @error="tratarErroImagem"
                        alt="logo"
                        class="logo-image"
                    />
                    <img
                        v-else
                        :src="logo"
                        id="logo"
                        alt="logo"
                    />
                </router-link>
            </div>

            <div class="menu-container">
                <NavMenu />
            </div>

            <template v-if="isMobile">
                <div
                    ref="wrapperRef"
                    class="perfil-mobile"
                >
                    <div class="mobile-icons">
                        <Search />

                        <div class="group-users">
                            <div class="dropDown">
                                <MenuIcon
                                    class="arrow menu-icon"
                                    :size="32"
                                    @click="alternarDropDown"
                                />
                            </div>

                            <div :class="['dropDown-menu', mostrarDropDown ? 'view' : 'hide']">
                                <router-link
                                    :to="`/${idioma}/dashboard/profile`"
                                    class="card-header-link"
                                    @click="alternarDropDown"
                                >
                                    <div class="card-header">
                                        <img
                                            v-if="dadosUsuario.avatar"
                                            :src="dadosUsuario.avatar"
                                            @error="tratarErroImagem"
                                            class="avatar-mobile"
                                            alt="foto"
                                        />
                                        <img
                                            v-else
                                            :src="defaultImage"
                                            class="avatar-mobile"
                                            alt="Avatar"
                                        />
                                        <div class="user-info">
                                            <span class="role-label">
                                                {{ empresaAtual?.company_role || 'Usuário' }}
                                            </span>
                                            <span class="user-name">{{ dadosUsuario.nome }}</span>
                                        </div>
                                    </div>
                                </router-link>

                                <div class="linha-dashed"></div>

                                <ul class="lista-opcoes">
                                    <template v-if="empresasUsuario && empresasUsuario.length > 0">
                                        <li
                                            v-for="empresa in empresasUsuario"
                                            :key="empresa.user_company_uuid"
                                            class="menu-item company-item"
                                            @click="trocarEmpresa(empresa.user_company_uuid)"
                                        >
                                            <div
                                                class="company-icon-bg"
                                                :style="{
                                                    backgroundColor: getColorForTheme(
                                                        empresa.company_color,
                                                    ),
                                                }"
                                            >
                                                <DomainIcon
                                                    :size="20"
                                                    fillColor="#fff"
                                                />
                                            </div>
                                            <div class="company-details">
                                                <span class="company-name">
                                                    {{ empresa.company_name }}
                                                </span>
                                                <span class="company-action">
                                                    {{ t('header.change_company') }}
                                                </span>
                                            </div>
                                        </li>
                                    </template>

                                    <li
                                        v-else
                                        class="menu-item company-item sem-empresas"
                                    >
                                        <span class="company-name">
                                            Nenhuma outra empresa vinculada
                                        </span>
                                    </li>
                                </ul>

                                <div class="footer-logout">
                                    <div
                                        class="sair-btn"
                                        @click="confirmarSaida"
                                    >
                                        <PowerIcon :size="24" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <template v-else>
                <div
                    ref="wrapperRef"
                    class="perfil"
                >
                    <div class="group-users">
                        <div
                            class="flex-row"
                            id="testeImg"
                        >
                            <img
                                v-if="dadosUsuario.avatar"
                                :src="dadosUsuario.avatar"
                                @error="tratarErroImagem"
                                class="border-image"
                                alt="foto"
                            />
                            <div
                                v-else
                                class="border-image"
                            >
                                <img
                                    class="border-image"
                                    id="profile-icon"
                                    :src="defaultImage"
                                    alt="Avatar"
                                />
                            </div>

                            <div class="administrador">
                                <div class="role">{{ empresaAtual?.company_role }}</div>
                                <div class="name">
                                    {{ dadosUsuario.nome }} {{ dadosUsuario.sobrenome }}
                                </div>
                            </div>
                            <ChevronDownIcon
                                class="arrow"
                                :size="36"
                                @click="alternarDropDown"
                            />
                        </div>

                        <div :class="['dropDown-menu', mostrarDropDown ? 'view' : 'hide']">
                            <ul>
                                <li class="editprofile">
                                    <router-link
                                        :to="`/${idioma}/dashboard/profile`"
                                        id="edittext"
                                        @click="alternarDropDown"
                                    >
                                        <p>{{ t('header.edit_profile') }}</p>
                                    </router-link>
                                </li>
                                <div class="linha"></div>
                                <template v-if="empresasUsuario">
                                    <li
                                        v-for="empresa in empresasUsuario"
                                        :key="empresa.user_company_uuid"
                                    >
                                        <div class="empresas">
                                            <div
                                                class="icon-bg2"
                                                :style="{
                                                    backgroundColor: getColorForTheme(
                                                        empresa.company_color,
                                                    ),
                                                }"
                                            >
                                                <DomainIcon
                                                    class="enterprise"
                                                    :size="24"
                                                />
                                            </div>
                                            <div class="dropdown-text">
                                                <h1>{{ empresa.company_name }}</h1>
                                                <router-link
                                                    to=""
                                                    id="change"
                                                    :style="{ display }"
                                                    @click="
                                                        trocarEmpresa(empresa.user_company_uuid)
                                                    "
                                                >
                                                    <p>{{ t('header.change_company') }}</p>
                                                </router-link>
                                            </div>
                                        </div>
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </div>
                    <div
                        class="sair"
                        @click="confirmarSaida"
                    >
                        <PowerIcon
                            class="off"
                            :size="29"
                            alt="Off"
                        />
                    </div>
                </div>
            </template>

            <ModalConfirmacao
                :mostrar="modalConfirmacao.mostrar"
                :mensagem="modalConfirmacao.mensagem"
                :titulo-botao="t('dashboard.receipt.btn_sair')"
                :icone="'meetingRoom'"
                @confirmar="handleConfirmarSaida"
                @cancelar="handleCancelarSaida"
                class="modal-cabecalho"
            />
        </div>
    </div>
</template>

<script>
    import { defineComponent, ref, onMounted, onUnmounted, computed } from 'vue'
    import { useRouter } from 'vue-router'
    import { useI18n } from 'vue-i18n'
    import { useEmpresaStore } from '@/stores/empresa'
    import { useUsuarioStore } from '@/stores/usuario'
    import { useAutenticacaoStore } from '@/stores/autenticacao'
    import NavMenu from './NavMenu.vue'
    import logo from '@/assets/images/logo.png'
    import ModalConfirmacao from '../ui/ModalConfirmacao.vue'
    import Menu from 'vue-material-design-icons/Menu.vue'
    import ChevronDown from 'vue-material-design-icons/ChevronDown.vue'
    import AccountOutline from 'vue-material-design-icons/AccountOutline.vue'
    import DomainIcon from 'vue-material-design-icons/Domain.vue'
    import PowerStandby from 'vue-material-design-icons/PowerStandby.vue'
    import Search from '../ui/Search.vue'
    import { apiService } from '@/api'
    import { useToastStore } from '@/stores/toast'
    import { BASE_URL } from '@/api/environment'

    export default defineComponent({
        name: 'Cabecalho',

        components: {
            NavMenu,
            ModalConfirmacao,
            MenuIcon: Menu,
            ChevronDownIcon: ChevronDown,
            AccountIcon: AccountOutline,
            DomainIcon,
            PowerIcon: PowerStandby,
            Search,
        },

        props: {
            idioma: {
                type: String,
                required: true,
            },
        },

        setup(props) {
            const router = useRouter()
            const { t } = useI18n()
            const empresaStore = useEmpresaStore()
            const usuarioStore = useUsuarioStore()
            const autenticacaoStore = useAutenticacaoStore()
            const toast = useToastStore()
            const defaultImage = new URL('@/assets/images/foto-perfil.svg', import.meta.url).href

            const wrapperRef = ref(null)
            const mostrarDropDown = ref(false)
            const display = ref('none')
            const isMobile = ref(false)
            const isTablet = ref(false)

            const logoEmpresaAtual = computed(() => {
                const logoPath = empresaStore.getLogo()
                if (logoPath && !logoPath.startsWith('http')) {
                    return `${BASE_URL}${logoPath}`
                }
                return logoPath
            })

            const empresaAtual = computed(() => empresaStore.empresaAtual)

            const dadosUsuario = computed(() => ({
                nome: usuarioStore.dadosUsuario.nome,
                sobrenome: usuarioStore.dadosUsuario.sobrenome,
                avatar: usuarioStore.dadosUsuario.avatar ? usuarioStore.dadosUsuario.avatar : null,
            }))

            const empresasUsuario = computed(() => {
                if (!empresaStore.listaEmpresas?.length) return []
                return empresaStore.listaEmpresas.filter(
                    (empresa) => empresa.company_id !== empresaAtual.value?.id,
                )
            })

            const alternarDropDown = () => {
                mostrarDropDown.value = !mostrarDropDown.value
                const menu = document.querySelector('.arrow')
                if (menu) menu.classList.toggle('rotate')
            }

            const tratarErroImagem = (event) => {
                const target = event.currentTarget
                target.onerror = null
            }

            const trocarEmpresa = async (newCompanyUuid) => {
                try {
                    const currentCompanyUuid = empresaStore.getUserCompanyId()
                    const resposta = await apiService.requisicao('changeCompany', {
                        current_id: currentCompanyUuid,
                        new_id: newCompanyUuid,
                    })

                    if (resposta.message === 'Company changed successfully.') {
                        const empresaDefinida = empresaStore.definirEmpresaAtual(newCompanyUuid)

                        if (!empresaDefinida) {
                            throw new Error('A empresa selecionada não foi encontrada no frontend.')
                        }

                        autenticacaoStore.definirEmpresaAtual(newCompanyUuid)

                        empresaStore.$persist?.()
                        autenticacaoStore.$persist?.()

                        if (mostrarDropDown.value) {
                            alternarDropDown()
                        }

                        window.location.assign(`/${props.idioma}/dashboard`)
                    }
                } catch (error) {
                    console.error('header.change_company_error', error)
                    toast.erro(t('header.change_company_error'))
                }
            }

            const fazerLogout = () => {
                usuarioStore.limparDadosUsuario()
                empresaStore.limparDadosEmpresa()
                autenticacaoStore.encerrarSessao()
                router.push({ name: 'Login', params: { locale: props.idioma } })
            }

            const modalConfirmacao = ref({
                mostrar: false,
                mensagem: '',
                tituloBotao: '',
                icone: '',
            })

            const confirmarSaida = async () => {
                modalConfirmacao.value = {
                    mostrar: true,
                    mensagem: t('header.modal_exit') + '?',
                    tituloBotao: t('dashboard.config.users.modal.confirm'),
                    icone: 'meetingRoom',
                }
            }

            const handleConfirmarSaida = async () => {
                modalConfirmacao.value.mostrar = false
                fazerLogout()
            }

            const handleCancelarSaida = () => {
                modalConfirmacao.value.mostrar = false
            }

            const verificarTamanhoTela = () => {
                const larguraTela = window.innerWidth
                isMobile.value = larguraTela <= 1149
                isTablet.value = larguraTela > 799 && larguraTela <= 1149
            }

            const getColorForTheme = (themeName) => {
                const themeColorMap = {
                    defaultTheme: '#174374',
                    copperTheme: '#c96428',
                    skyBlueTheme: '#618ec2',
                    amberTheme: '#dc7a27',
                    greenTheme: '#169b3b',
                    orangeTheme: '#fca600',
                    magentaTheme: '#cf0459',
                    purpleTheme: '#472988',
                    brownTheme: '#a52a2a',
                    greyTheme: '#767656',
                    oliveTheme: '#728500',
                    mysticTurquoiseTheme: '#00857a',
                    cobaltBlueTheme: '#0561a6',
                    sagatPurpleTheme: '#7035cc',
                    ultraVioletTheme: '#645394',
                    tomatoTheme: '#bf0c0c',
                    ribbonTheme: '#e63244',
                    orchidTheme: '#bf45ac',
                    trueBlueTheme: '#0008c9',
                    ashenvaleTheme: '#0f3276',
                    graspingTheme: '#90b400',
                    marlinTheme: '#3fa5a5',
                    dirtyYellowTheme: '#d1c906',
                    carbonTheme: '#2f2f2f',
                }
                return themeColorMap[themeName] || '#174374'
            }

            onMounted(() => {
                verificarTamanhoTela()
                window.addEventListener('resize', verificarTamanhoTela)

                setTimeout(() => {
                    display.value = 'block'
                }, 2500)

                const handleClickOutside = (event) => {
                    if (
                        mostrarDropDown.value &&
                        wrapperRef.value &&
                        !wrapperRef.value.contains(event.target)
                    ) {
                        alternarDropDown()
                    }
                }
                document.addEventListener('mousedown', handleClickOutside)

                onUnmounted(() => {
                    window.removeEventListener('resize', verificarTamanhoTela)
                    document.removeEventListener('mousedown', handleClickOutside)
                })

                if (!empresaStore.empresaAtual && empresaStore.listaEmpresas.length > 0) {
                    empresaStore.definirEmpresaAtual(empresaStore.listaEmpresas[0])
                }
            })

            return {
                wrapperRef,
                mostrarDropDown,
                display,
                logoEmpresaAtual,
                isMobile,
                isTablet,
                empresaAtual,
                dadosUsuario,
                empresasUsuario,
                logo,
                defaultImage,
                alternarDropDown,
                tratarErroImagem,
                trocarEmpresa,
                confirmarSaida,
                t,
                modalConfirmacao,
                handleConfirmarSaida,
                handleCancelarSaida,
                getColorForTheme,
                idioma: props.idioma,
            }
        },
    })
</script>

<style lang="scss" scoped>
    body p,
    body h1 {
        margin: 0;
    }

    /* ================= ESTILO GERAL E DESKTOP ================= */
    .linha2 {
        display: flex;
        background-color: var(--white);
        border-radius: 0 0 1.25rem 1.25rem;
        box-shadow: 0 0.4vh 0.4vh #00000026;
        height: 4.2rem;
        width: 100%;
        z-index: 99;
        position: fixed;
        align-content: center;
        justify-content: center;
        align-items: center;
        padding: 0 1.92rem;

        .main-header {
            display: flex;
            height: 4.2rem;
            width: 100%;
            max-width: 2500px;
            z-index: 99;
            align-items: center;

            .empresa {
                height: 70%;
                display: flex;
                align-items: center;
                a {
                    height: 100%;
                    display: inline-block;
                }
                img {
                    height: 100%;
                    width: auto;
                    object-fit: contain;
                }
            }

            #logo {
                width: 8rem;
            }

            .perfil {
                display: flex;
                flex-direction: row;
                margin-left: auto;
                align-items: center;
            }

            .perfil-mobile {
                display: none;
            }

            .foto {
                height: 3.25rem;
                object-fit: cover;
                position: relative;
                margin-left: 0.188rem;
            }

            #profile-icon {
                color: var(--colorOpacity60);
            }

            .group-users {
                display: flex;
                flex-direction: column;
                background-color: #fff;
                gap: 0.84rem;
                margin-right: 1.92rem;
                position: relative;

                .flex-row {
                    gap: 0.84rem;
                    display: flex;
                    align-items: center;
                    align-self: center;
                }
            }

            .administrador {
                color: var(--lightgrey);
                font-size: var(--font-size-xs);
                font-weight: 400;
                display: flex;
                flex-direction: column;

                .role {
                    color: var(--lightgrey);
                    font-size: var(--font-size-xs);
                    font-weight: 400;
                }

                .name {
                    color: var(--gray);
                    font-size: var(--font-size-l);
                    font-weight: 700;
                }
            }

            .logo-image {
                max-width: none;
                max-height: none;
            }

            .arrow {
                color: #b6b9c2;
                cursor: pointer;
                transform: rotate(0deg);
                transition: 0.3s;
            }

            .rotate {
                transform: rotate(180deg);
            }

            .sair {
                border: 0.063rem solid #464646;
                border-radius: 50%;
                height: 2.5rem;
                width: 2.5rem;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                position: relative;

                .off {
                    color: #464646;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);

                    &:hover {
                        color: var(--colorOpacity100);
                        transition: 0.4s;
                    }
                }

                &:hover {
                    border-color: var(--colorOpacity100);
                    transition: 0.4s;
                }
            }

            .dropDown-menu {
                position: absolute;
                top: 100%;
                right: 0;
                width: 15rem;
                height: auto;
                background: #fff;
                box-shadow: 0 0.4vh 0.4vh 0 rgba(0, 0, 0, 0.25);
                border-radius: 0 0 1.25rem 1.25rem;
                user-select: none;
                transition: 0.4s;
                transform-origin: top;
                padding: 1rem;

                &.view {
                    opacity: 1;
                    transform: scaleY(1);
                }

                &.hide {
                    opacity: 0;
                    transform: scaleY(0);
                }

                ul {
                    display: flex;
                    flex-direction: column;
                    background-color: #fff;
                    list-style: none;
                    margin: 0;
                    padding: 0;

                    li a {
                        display: flex;
                        align-items: center;
                        text-decoration: none;
                        color: #262626;
                        font-size: var(--font-size-xs);
                        font-weight: 400;
                        text-decoration-line: none;
                        position: relative;
                    }

                    li h1 {
                        font-size: var(--font-size-m);
                        font-weight: 500;
                        position: relative;
                    }
                }

                p {
                    text-decoration-line: underline;
                }

                .editprofile {
                    &::before {
                        content: '•';
                        color: var(--colorOpacity60);
                        position: absolute;
                        left: -1.68rem;
                        top: 50%;
                        transform: translateY(-50%);
                        font-size: 2rem;
                        border-radius: 50%;
                    }
                    list-style: none;
                    position: relative;
                    margin-left: 1.68rem;

                    #edittext {
                        font-size: var(--font-size-m);
                        font-weight: 400;
                        color: #262626;
                    }
                }
            }

            .linha {
                width: 99%;
                border: dashed 0.063rem #b5aeae;
                align-self: center;
                position: relative;
                margin-top: 1rem;
            }

            .empresas {
                display: flex;
                flex-direction: row;
                margin-top: 1.5rem;
                align-items: center;
                gap: 1.25rem;
            }

            .enterprise {
                position: relative;
                color: #fff;
            }

            .icon-bg,
            .icon-bg2 {
                width: 3rem;
                height: 3rem;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .icon-bg {
                background-color: #169b3b;
            }

            .dropdown-text {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                margin-top: 0;
                gap: 0.313rem;
            }

            .border-image {
                position: relative;
                width: 3rem;
                height: 3rem;
                border-radius: 50%;
            }

            .menu-container {
                position: absolute;
                left: 0;
                right: 0;
                bottom: 1.375rem;
                display: flex;
                justify-content: center;
            }
        }
    }

    /* ================= MOBILE ================= */
    @media only screen and (max-width: 1149px) {
        .linha2 {
            padding: 0;

            .main-header {
                justify-content: space-between;
                height: 4.5rem;
                padding: 0 1.5rem;
                position: relative;

                .empresa {
                    height: auto;
                    #logo,
                    .logo-image {
                        height: 2.5rem;
                        width: auto;
                    }
                }

                .menu-container {
                    display: none;
                }
                .perfil {
                    display: none;
                }

                .perfil-mobile {
                    display: flex;
                    align-items: center;

                    .mobile-icons {
                        display: flex;
                        align-items: center;
                        gap: 1rem;
                    }

                    :deep(.search-main:not(.search-open)) {
                        background-color: transparent !important;
                        border: none !important;

                        .circle {
                            background-color: transparent !important;
                            border: 1px solid var(--colorOpacity60) !important;
                            border-radius: 100% !important;
                            width: 2.7rem;
                            height: 2.7rem;

                            .material-symbols-outlined {
                                color: var(--colorOpacity60) !important;
                            }

                            &:hover {
                                background-color: var(--colorOpacity60) !important;

                                .material-symbols-outlined {
                                    color: white !important;
                                }
                            }
                        }
                    }
                    .group-users {
                        position: static;
                        background-color: transparent;
                        margin-right: 0;
                        gap: 0;

                        .dropDown {
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            color: var(--gray);
                        }

                        /* CARD FLUTUANTE */
                        .dropDown-menu {
                            position: absolute;
                            top: 4.5rem;
                            right: 1rem;
                            width: 18rem;
                            background: #fff;
                            border-radius: 12px;
                            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
                            padding: 1.5rem;
                            z-index: 100;
                            transform-origin: top right;
                            transition: all 0.3s ease;

                            &.hide {
                                opacity: 0;
                                transform: scale(0.95);
                                pointer-events: none;
                            }
                            &.view {
                                opacity: 1;
                                transform: scale(1);
                                pointer-events: all;
                            }

                            .card-header-link {
                                text-decoration: none;
                                display: block;
                                color: inherit;
                            }

                            .card-header {
                                display: flex;
                                align-items: center;
                                gap: 1rem;
                                margin-bottom: 1rem;
                                cursor: pointer;

                                .avatar-mobile {
                                    width: 3rem;
                                    height: 3rem;
                                    border-radius: 50%;
                                    object-fit: cover;
                                }

                                .user-info {
                                    display: flex;
                                    flex-direction: column;

                                    .role-label {
                                        font-size: 0.75rem;
                                        color: #999;
                                    }

                                    .user-name {
                                        font-size: 1rem;
                                        font-weight: bold;
                                        color: #333;
                                        word-break: break-word;
                                    }
                                }
                            }

                            .linha-dashed {
                                border-bottom: 1px dashed #ccc;
                                margin-bottom: 1rem;
                                width: 100%;
                            }

                            .lista-opcoes {
                                list-style: none;
                                padding: 0;
                                margin: 0;
                                display: flex;
                                flex-direction: column;
                                gap: 1rem;

                                .sem-empresas {
                                    font-size: 0.8rem;
                                    color: #999;
                                    text-align: center;
                                }

                                .company-item {
                                    display: flex;
                                    align-items: center;
                                    gap: 0.8rem;
                                    cursor: pointer;

                                    .company-icon-bg {
                                        width: 2.5rem;
                                        height: 2.5rem;
                                        border-radius: 50%;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        flex-shrink: 0;
                                    }

                                    .company-details {
                                        display: flex;
                                        flex-direction: column;

                                        .company-name {
                                            font-weight: bold;
                                            font-size: 0.9rem;
                                            color: #333;
                                        }

                                        .company-action {
                                            font-size: 0.75rem;
                                            color: #666;
                                            text-decoration: underline;
                                        }
                                    }
                                }
                            }

                            .footer-logout {
                                display: flex;
                                justify-content: flex-end;
                                margin-top: 1.5rem;

                                .sair-btn {
                                    width: 2.5rem;
                                    height: 2.5rem;
                                    border-radius: 50%;
                                    border: 1px solid #ccc;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    color: #666;
                                    cursor: pointer;
                                    transition: 0.2s;
                                    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);

                                    &:hover {
                                        border-color: var(--colorOpacity60);
                                        color: var(--colorOpacity60);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .menu-icon {
        color: #464646 !important;
        border: 1px solid #464646 !important;
        border-radius: 100% !important;
        padding: 0.25rem !important;
    }
</style>
